export default '/build/bfe47cce.svg'